import React, { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import './scss/styles.scss';
import { BrowserRouter as Router } from 'react-router-dom';
import { navbarSyncDataSubject$, SyncDataSubject } from './sharedSubjects';
import { queryKeys } from './hooks/queryKeyFactory';
import Base from './Base';

const QUERY_RETRY_COUNT = 3;

function shouldRetry(failureCount: number, error): boolean {
  return error?.response?.status !== 404 && failureCount < QUERY_RETRY_COUNT;
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: shouldRetry,
    },
  },
});

const Index = function Root(): React.ReactElement {
  useEffect(() => {
    const navbarSubject = navbarSyncDataSubject$.subscribe((subject) => {
      switch (subject) {
        case SyncDataSubject.USER_PROFILE:
          queryClient.invalidateQueries([queryKeys.fetchProfile]);
          break;
        case SyncDataSubject.SAVED_SEARCH:
          queryClient.invalidateQueries([queryKeys.savedSearches.all]);
          break;
        default:
          break;
      }
      if (subject) {
        navbarSyncDataSubject$.next(null);
      }

      return () => {
        navbarSubject.unsubscribe();
      };
    });
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <Base />
      </Router>
    </QueryClientProvider>
  );
};

export default Index;
